import { site } from "./site";
import { services } from "./services";

const communesFor = (ville) =>
  site.zones
    .filter((z) => z.ville === ville)
    .flatMap((z) => z.communes);

const baseServices = services.map((s) => s.title);

export const villes = {
  charleroi: {
    slug: "jardinier-charleroi",
    name: "Charleroi",
    seoTitle: "Jardinier à Charleroi — Entretien de jardins, taille de haies, pelouse | Embek Group",
    seoDesc:
      "Embek Group, votre jardinier à Charleroi : entretien de jardins, tonte de pelouse, taille de haies, aménagement paysager, nettoyage extérieur et vide-cave. Devis gratuit, rendez-vous en ligne.",
    headerTitle: "Jardinier à Charleroi",
    headerDesc:
      "Entretien de jardins, tailles, pelouses, aménagement et vide-cave à Charleroi et dans les communes voisines — avec professionnalisme, précision et passion.",
    intro: [
      "Vous cherchez un jardinier à Charleroi ? Embek Group prend soin des jardins et espaces verts de la ville et de ses alentours : tonte de pelouse, taille de haies et d'arbustes, désherbage, nettoyage extérieur, création et aménagement paysager, ainsi que le vide-cave et le débarras.",
      "Nos équipes se déplacent dans toutes les communes listées ci-dessous, pour une intervention ponctuelle ou un contrat d'entretien régulier. Demandez votre devis gratuit ou réservez directement votre créneau en ligne.",
    ],
    communes: communesFor("charleroi"),
    services: baseServices,
    mapQuery: "Charleroi,+Belgique",
  },
  namur: {
    slug: "jardinier-namur",
    name: "Namur",
    seoTitle: "Jardinier à Namur — Entretien de jardins et espaces verts | Embek Group",
    seoDesc:
      "Embek Group, votre entreprise de jardinage à Namur : entretien de jardins, tonte de pelouse, taille de haies, création et aménagement paysager, nettoyage extérieur. Devis gratuit, rendez-vous en ligne.",
    headerTitle: "Jardinier à Namur",
    headerDesc:
      "Embek Group entretient et valorise les jardins de Namur et des communes environnantes : tonte, tailles, aménagement paysager, nettoyage extérieur et vide-cave.",
    intro: [
      "À Namur et dans la région, Embek Group accompagne les particuliers pour l'entretien régulier ou ponctuel de leur jardin : tonte de pelouse, taille de haies et d'arbustes, entretien des massifs, nettoyage des abords et remise en état des terrains.",
      "Envie d'un nouvel espace vert ? Nous réalisons aussi la création et l'aménagement paysager, la plantation de massifs et la pose de gazon. Nos interventions couvrent l'ensemble des communes ci-dessous — devis gratuit ou rendez-vous en ligne.",
    ],
    communes: communesFor("namur"),
    services: baseServices,
    mapQuery: "Namur,+Belgique",
  },
  mons: {
    slug: "jardinier-mons",
    name: "Mons",
    seoTitle: "Jardinier à Mons — Entretien de jardins, haies et pelouses | Embek Group",
    seoDesc:
      "Embek Group, votre jardinier à Mons et dans les localités voisines : entretien de jardins, taille de haies, tonte de pelouse, aménagement paysager, nettoyage et vide-cave. Devis gratuit.",
    headerTitle: "Jardinier à Mons",
    headerDesc:
      "De Mons à ses localités — Cuesmes, Ghlin, Jemappes, Obourg et au-delà — Embek Group entretient vos jardins et espaces verts avec soin et précision.",
    intro: [
      "Embek Group intervient à Mons et dans toutes les localités de la région : entretien régulier de jardin, tonte de pelouse, taille de haies et d'arbustes, désherbage, nettoyage des terrasses et des abords, remise en état des terrains et vide-cave.",
      "Vous avez un projet de création ou d'aménagement paysager ? Nous vous accompagnons du conseil à la plantation. Retrouvez l'ensemble des zones desservies ci-dessous et demandez votre devis gratuit ou réservez votre créneau en ligne.",
    ],
    communes: [...communesFor("mons"), ...site.zones[3].communes],
    services: baseServices,
    mapQuery: "Mons,+Belgique",
  },
};

// ─────────────────────────────────────────────────────────────────────────────
// Index des communes pour les pages SEO locales (/jardinier-<slug>)
// ─────────────────────────────────────────────────────────────────────────────
export const slugify = (name) =>
  name
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const parentOf = (zoneName) =>
  zoneName.startsWith("Charleroi")
    ? "charleroi"
    : zoneName.startsWith("Namur")
      ? "namur"
      : zoneName.startsWith("Mons")
        ? "mons"
        : null;

export const communesIndex = {};
site.zones.forEach((z) => {
  const parent = parentOf(z.name);
  if (!parent) return;
  z.communes.forEach((c) => {
    const slug = slugify(c);
    communesIndex[slug] = { name: c, slug, ville: parent };
  });
});
Object.values(communesIndex).forEach((info) => {
  info.siblings = Object.values(communesIndex).filter(
    (x) => x.ville === info.ville && x.slug !== info.slug
  );
});

export const communeSlug = (name) => slugify(name);
